// 注册 Service Worker
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.BASE_URL}service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then(registration => {
          console.log('[SW] Service Worker registered:', registration);

          // 检查更新
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('[SW] New Service Worker found');

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // 新的 Service Worker 已安装，提示用户更新
                console.log('[SW] New content available, please refresh');
                
                // 可以在这里显示更新提示
                if (confirm('发现新版本，是否立即更新？')) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          });

          // 定期检查更新（每小时）
          setInterval(() => {
            registration.update();
          }, 60 * 60 * 1000);
        })
        .catch(error => {
          console.error('[SW] Service Worker registration failed:', error);
        });

      // 监听 Service Worker 控制器变化
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[SW] Controller changed, reloading page');
          window.location.reload();
        }
      });

      // 监听来自 Service Worker 的消息
      navigator.serviceWorker.addEventListener('message', event => {
        const { data } = event;
        
        if (data.type === 'NEW_VERSION_AVAILABLE') {
          console.log('[SW] New version available:', data.newVersion);
          
          // 显示更新提示
          const message = `发现新版本 ${data.newVersion}\n当前版本 ${data.currentVersion}\n是否立即更新？`;
          if (confirm(message)) {
            // 通知 Service Worker 跳过等待
            if (navigator.serviceWorker.controller) {
              navigator.serviceWorker.controller.postMessage({
                type: 'SKIP_WAITING'
              });
            }
            // 刷新页面
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        }
        
        if (data.type === 'SW_ACTIVATED') {
          console.log('[SW] Service Worker activated, version:', data.version);
        }
      });

      // 页面可见时检查更新
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage({
            type: 'CHECK_VERSION'
          });
        }
      });

      // 微信环境特殊处理
      window.addEventListener('pageshow', (e) => {
        if (e.persisted && navigator.serviceWorker.controller) {
          // 页面从缓存恢复，检查更新
          navigator.serviceWorker.controller.postMessage({
            type: 'CHECK_VERSION'
          });
        }
      });
    });
  }
}

// 注销 Service Worker
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error('[SW] Service Worker unregistration failed:', error);
      });
  }
}

// 清除所有缓存
export function clearCache() {
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      return Promise.all(
        cacheNames.map(cacheName => {
          console.log('[SW] Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }).then(() => {
      console.log('[SW] All caches cleared');
      window.location.reload();
    });
  }
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js